import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { CyptolandingComponent } from './cyptolanding/cyptolanding.component';
import { Page404Component } from './extrapages/page404/page404.component';
import { StoreComponent } from './store/store/store.component';
import { LedgerDetailsComponent } from './pages/financialaccounting/ledger-details/ledger-details.component';
import { BalanceDetailsComponent } from './pages/financialaccounting/balance-details/balance-details.component';
import { ProfitlossDetailsComponent } from './pages/financialaccounting/profitloss-details/profitloss-details.component';
const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'epage',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'ledger-details/:ledgerId',
        component: LedgerDetailsComponent,
      },
      {
        path: 'balance-details/:ledgerId',
        component: BalanceDetailsComponent,
      },
      {
        path: 'profit&loss-details/:ledgerId',
        component: ProfitlossDetailsComponent,
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: 'extrapages',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./extrapages/extrapages.module').then((m) => m.ExtrapagesModule),
  },
  {
    path: 'crypto-ico-landing',
    component: CyptolandingComponent,
  },
  {
    path: 'store',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./store/store.module').then((m) => m.StoreModule),
  },
  {
    path: '**',
    component: Page404Component,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
